// extracted by mini-css-extract-plugin
module.exports = {"root":"CodeBox_root__2NKxj","line":"CodeBox_line__hvUvC","lineNum":"CodeBox_lineNum__1lIe-","code":"CodeBox_code__3mISS"};